import { lazy } from 'react';

/**
 * Lazy-loaded branded page loader animation.
 *
 * `LottieGraphic` pulls in `lottie-web` (~250 KB). `PageLoading` lives in the
 * main/critical chunk (imported by the app shell), so we lazy-import both the
 * runtime and the JSON here to keep them in their own on-demand chunk rather
 * than the initial bundle.
 */
const AnimatedPageLoaderGraphic = lazy(async () => {
    const [{ default: LottieGraphic }, { default: pageLoaderJSON }] = await Promise.all([
        import('@components/graphics/LottieGraphic'),
        import('@components/graphics/lottie/SP_Loader1-loop.json'),
    ]);

    return {
        default: function PageLoaderGraphic() {
            return (
                <LottieGraphic
                    className="h-12 w-12"
                    json={pageLoaderJSON}
                    startPlay
                    loop
                    renderer="svg"
                />
            );
        },
    };
});

export default AnimatedPageLoaderGraphic;
